module.exports = __webpack_public_path__ + "static/media/education.9494e2d0.svg";